import { useMutation, useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { IQueryOptions } from ".";
import { IApplicationState } from "@/store-redux";
import {
  deleteNotification,
  getNotifications,
  getUnreadCount,
  markAllNotificationsAsRead,
  markNotificationAsRead,
} from "../api/notification.service";
import {
  markRead,
  markAllRead,
  removeNotification,
  setUnreadCount,
  setNotifications,
} from "@/store-redux/slices/notificationSlice";

export const useGetNotifications = (page = 1, options: IQueryOptions = {}) => {
  const dispatch = useDispatch();
  const currentUser = useSelector((state: IApplicationState) => state.currentUser);
  const userId = currentUser?.data?._id;

  return useQuery(["GET_NOTIFICATIONS", page], () => getNotifications(page), {
    enabled: !!userId,
    keepPreviousData: true,
    ...options,
  });
};

/** Polling fallback every 30s for unread badge count */
export const useGetUnreadCount = (options: IQueryOptions = {}) => {
  const dispatch = useDispatch();
  const isConnected = useSelector((state: IApplicationState) => state.notification.isConnected);
  const currentUser = useSelector((state: IApplicationState) => state.currentUser);
  const userId = currentUser?.data?._id;

  return useQuery(["GET_NOTIFICATIONS_UNREAD_COUNT"], getUnreadCount, {
    enabled: !!userId,
    refetchInterval: userId && !isConnected ? 30_000 : false,
    onSuccess: (data) => {
      dispatch(setUnreadCount(data.count));
    },
    ...options,
  });
};

export const useMarkNotificationAsRead = (options: IQueryOptions = {}) => {
  const dispatch = useDispatch();
  return useMutation(markNotificationAsRead, {
    onSuccess: (_, id) => {
      dispatch(markRead(id));
    },
    ...options,
  });
};

export const useMarkAllNotificationsAsRead = (options: IQueryOptions = {}) => {
  const dispatch = useDispatch();
  return useMutation(markAllNotificationsAsRead, {
    onSuccess: () => {
      dispatch(markAllRead());
    },
    ...options,
  });
};

export const useDeleteNotification = (options: IQueryOptions = {}) => {
  const dispatch = useDispatch();
  return useMutation(deleteNotification, {
    onSuccess: (_, id) => {
      dispatch(removeNotification(id));
    },
    ...options,
  });
};
